import React, { useState, useEffect } from "react";
import StaticProgressBar from "components/controls/StaticProgressBar/StaticProgressBar";
import Card from "components/Card/Card";
import useApi from "hooks/useApi";
import WithApi from "components/ui/WithApi/WithApi";
import {
  GetCities,
  GetCitiesDropDownList
} from "api/apiService";
import DropDown from "../controls/DropDown/DropDown";
import { useAppSelector } from "../../redux/hooks";
import { useYearFromRedux } from "utils/utilsLogic";
import Const from "const.json";
import { EntityComplaint } from "types/EntityComplaint";
import "bootstrap/dist/css/bootstrap.min.css";

const DistributionOfComplaintsByResidence: React.FC = () => {

  const { comparisonTextToLastYear } = useYearFromRedux();
  const { callApi, data, loading, error } = useApi<EntityComplaint[]>(GetCities);

  const { period } = useAppSelector((state) => state.general);

  useEffect(() => {
    callApi();
  }, [period]);

  const handleSelectOption = (optionId?: string) => {
    callApi(optionId);
  };

  return (
    <div>
      <Card
        header={Const.complaintsDistributionByCities}
        subHeader={`${Const.citiesLeadingComplaintsNumber}\n${comparisonTextToLastYear}`}
        components={[
          <DropDown
            options={GetCitiesDropDownList}
            title={Const.selectComplaintCity}
            placeholder={Const.typeComplaintCity}
            onSelect={handleSelectOption}
          />,
          <WithApi data={data} loading={loading} error={error}>
            <StaticProgressBar
              progressBarAriaLabel={Const.districtOfComplainantArrangedDescendingOrderOfNumberOfComplaints}
              complaints={data}
              showIcon={false}
            />
          </WithApi>,
        ]}
      />
    </div>
  );
};

export default DistributionOfComplaintsByResidence;
